// Shared event name so the (globally-mounted, bottom-right) toaster can ask the
// (header-mounted) notification center to open, without either importing the
// other's component module. The toast is a transient pointer into the durable
// center (design §4): clicking it opens the center rather than deep-linking.
export const OPEN_CENTER_EVENT = "practicemd:open-notification-center"
